export default "__VITE_ASSET__471feff7__"